import Link from "next/link";
import Image from "next/image";
import { HERO_CONFIG } from "@/data/hero";
import { cn } from "@/lib/utils";

interface LogoProps {
  scrolled?: boolean;
}

export function Logo({ scrolled = false }: LogoProps) {
  const logo = scrolled ? HERO_CONFIG.logoScrolled : HERO_CONFIG.logo;

  return (
    <Link
      href="/"
      className="relative z-10 flex items-center transition-opacity duration-200 hover:opacity-80"
    >
      <Image
        src={logo.src}
        alt={logo.alt}
        width={220}
        height={70}
        priority
        className={cn(
          "w-auto object-contain transition-all duration-500",
          scrolled ? "h-16" : "h-20"
        )}
      />
    </Link>
  );
}